export default prefix => /\[([0-9])\]/.exec(prefix)?.[1];
